import React from 'react';
import { Container, Paper, Typography, Box, Button, Grid, Card, CardContent, CardMedia, List, ListItem, ListItemIcon, ListItemText, Tabs, Tab } from '@mui/material';
import { Event, LocationOn, AccessTime, Schedule, BusinessCenter } from '@mui/icons-material';
import { Fade, Slide } from 'react-awesome-reveal';
import Link from 'next/link';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const EventPage = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const agenda = [
        { time: '7:30 AM', event: 'Breakfast and Registration' },
        { time: '8:30 AM', event: 'Welcome - Goals with Summit and Logistics' },
        { time: '8:40 AM', event: 'Introductions' },
        { time: '9:00 AM', event: 'KY Climate 101: An Introduction to KY Climate & Resources' },
        { time: '10:00 AM', event: 'Break' },
        { time: '10:30 AM', event: 'Breakout Session 1' },
        { time: '11:00 AM', event: 'Federal Climate Tools and Resources for the Commonwealth' },
        { time: '12:00 PM', event: 'Lunch' },
        { time: '1:00 PM', event: 'New State EPSCoR Grant: Climate Mitigation' },
        { time: '1:10 PM', event: 'Upcoming Kentucky Climate Symposium, Sep. 26, 2024' },
        { time: '1:20 PM', event: 'Panel Discussion 1: Energy & Transportation' },
        { time: '2:00 PM', event: 'Panel Discussion 2: Water & Agriculture' },
        { time: '2:45 PM', event: 'Break' },
        { time: '3:15 PM', event: 'Panel Discussion 3: Environment & Conservation' },
        { time: '4:00 PM', event: 'Breakout Session 2' },
        { time: '5:00 PM', event: 'Adjourn for the day. Resume at The Brown Barrel & Blind Harry\'s for dinner (Frankfort, KY)' }
    ];

    const agenda2 = [
        { time: '7:30 AM', event: 'Breakfast' },
        { time: '8:30 AM', event: 'Summary from Day 1' },
        { time: '8:45 AM', event: 'Panel Discussion 4: Industry & Commerce' },
        { time: '9:30 AM', event: 'Panel Discussion 5: Media & Forecast Providers' },
        { time: '10:15 AM', event: 'Break' },
        { time: '10:45 AM', event: 'Panel Discussion 6: Hazard Mitigation & Emergency Management' },
        { time: '11:30 AM', event: 'Group Discussion: What\'s Missing? Next Steps?' },
        { time: '12:00 AM', event: 'Final Observations & Adjourn' },
        { time: '12:15 PM', event: 'Lunch' }
    ];

    return (
        <body style={{ backgroundColor: "#14213d" }}>
            <Container maxWidth="lg" sx={{ my: 5 }}>
                <title>Kentucky Climate Services Summit 2024</title>
                <Paper elevation={3} style={{ padding: '2rem', borderRadius: '15px' }}>
                    <Box textAlign="center" mb={4} position="relative">
                        <Fade in>
                            <img
                                src={"/DORT_042524.jpg"}
                                alt="Event"
                                style={{ width: '100%', borderRadius: '15px', position: 'relative', zIndex: 1, minHeight: '500px' }}
                            />
                        </Fade>
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 2,
                                color: "white",
                                textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
                                p: 2,
                                textAlign: 'center'
                            }}
                        >
                            <Typography variant={{ xs: 'h5', sm: 'h2', md: 'h3' }} component="h1" gutterBottom>
                                Kentucky Climate Services Summit 2024
                            </Typography>
                            <Typography variant={{ xs: 'body1', sm: 'h6', md: 'h5' }} gutterBottom>
                                July 16-17, 2024 | Capital Plaza Hotel, Frankfort, KY
                            </Typography>
                            <Button
                                sx={{ my: 5, color: "white" }}
                                variant="outlined"
                                size="large"
                                href='https://docs.google.com/forms/d/e/1FAIpQLSfkjinnudlMzbYIBGe7hZOSAFRliNWm07X9Kr2sHfZV37ZedA/viewform'
                                target='_blank'
                            >
                                Register Now
                            </Button>
                            <Typography variant={{ xs: 'body2', sm: 'subtitle1' }}>
                                Note: The Summit is FREE! No registration fee is required.
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2} >
                            <Grid spacing={{ xs: 12, sm: 6 }} sx={{ display: 'flex', alignItems: 'center' }}>
                                <AccessTime style={{ marginRight: '8px' }} />
                                <Typography variant="body1">July 16-17, 2024, 7:30 AM - 5:00 PM | 7:30 AM - 12:00 PM</Typography>
                            </Grid>
                            <Grid spacing={{ xs: 12, sm: 6 }} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocationOn style={{ marginRight: '8px' }} />
                                <Typography variant="body1">Capital Plaza Hotel, Frankfort, KY</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Fade>
                        <Typography variant="h5" gutterBottom>
                            Summit Objective
                        </Typography>
                        <Typography variant="body1" paragraph>
                            To set forth a vision for Kentucky whereby state entities are provided complete and comprehensive climate data services to increase and perfect public safety, resiliency, and economic efficiency.
                        </Typography>
                        <Typography variant="h5" gutterBottom>
                            Goals
                        </Typography>
                        <Typography variant="body1" paragraph>
                            <ul>
                                <li>Build increased awareness of existing climate tools, data, individuals, and expertise.</li>
                                <li>Identify climate services needs and gaps within the state.</li>
                                <li>Improve coordination and collaboration among climate service providers and users at the local, state, regional, and national levels.</li>
                                <li>Identify opportunities to seek out additional resources.</li>
                            </ul>
                        </Typography>
                    </Fade>

                    <Box my={4}>
                        <Fade>
                            <Typography variant="h5" gutterBottom>
                                Hotel Registration
                            </Typography>
                            <Typography variant="body1" paragraph>
                                A block of rooms has been set aside at the Capital Plaza Hotel.
                                To make reservations, you may call the hotel direct at <Link href='tel:5022275100'>502-227-5100</Link>, or go online at <Link href="https://capitalplazaky.com/">www.capitalplazaky.com</Link> and apply Group code: <b>5812</b>.
                                The group code is associated with the "KCC Climate Workshop".
                                Rooms are available for $119 per night (excluding tax).
                            </Typography>
                            <Typography variant="h5" gutterBottom>
                                Directions to the Capital Plaza Hotel
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>Address:</strong> 405 Wilkinson Boulevard, Frankfort, Kentucky 40601
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>From Louisville:</strong> Take I-64E, Exit #53B. Take US-127N for 4.6 miles. Turn left onto Wilkinson Blvd.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>From Lexington:</strong> Follow US-421 N/Leestown Rd. Continue onto E-W Connector to Frankfort. Turn left onto E. Main St for 0.7 miles. Continue onto E. Broadway St. Dr. to Wilkinson Blvd.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>From Bowling Green:</strong> Follow the Bluegrass Parkway east, Take Exit #59B. Take US-127N for 18.4 miles. Turn left onto Wilkinson Blvd.
                            </Typography>
                        </Fade>
                    </Box>
                    <Box my={4}>
                        <Typography variant="h5" gutterBottom>
                            Agenda
                        </Typography>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label="Tuesday, July 16th"></Tab>
                            <Tab label="Wednesday, July 17th"></Tab>
                        </Tabs>
                        <CustomTabPanel value={value} index={0}>
                            <List>
                                {agenda.map((item, index) => (
                                    <Fade key={index}>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Schedule />
                                            </ListItemIcon>
                                            <ListItemText primary={`${item.time} - ${item.event}`} />
                                        </ListItem>
                                    </Fade>
                                ))}
                            </List>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <List>
                                {agenda2.map((item, index) => (
                                    <Fade key={index}>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Schedule />
                                            </ListItemIcon>
                                            <ListItemText primary={`${item.time} - ${item.event}`} />
                                        </ListItem>
                                    </Fade>
                                ))}
                            </List>
                        </CustomTabPanel>

                    </Box>
                    <Box textAlign="center" my={5}>
                        <Button variant="contained" color="primary" size="large" href='https://docs.google.com/forms/d/e/1FAIpQLSfkjinnudlMzbYIBGe7hZOSAFRliNWm07X9Kr2sHfZV37ZedA/viewform' target="_blank">
                            Register Now
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </body>

    );
};

export default EventPage;